import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component((node) => {
  const drawerElem:HTMLElement = node.querySelector('[data-faq-category]');
  const drawer = Drawer(drawerElem);
  const triggers = [...document.querySelectorAll<HTMLElement>('[data-triggers="faq-category"]')];
  const closeCategoryDrawer = node.querySelector('[data-close-faq-category]');

  if (!drawer || !triggers.length) return;

  let isOpen = false;

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.toggle();
      isOpen = !isOpen;
    });
  });

  closeCategoryDrawer.addEventListener('click', () => {
    drawer.close();
  });
});
